import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActiveRentals, getUser } from '../../../Redux/Actions/actions';
import RentalCard from '../../../Components/RentalCard/RentalCard';
import style from './ActiveContracts.module.css';

const ActiveContracts = () => {
  const dispatch = useDispatch();
  const { activeRentals, rentalsLoading, rentalsError } = useSelector(state => state);
  const [filters, setFilters] = useState({
    status: 'active',
    search: '',
    page: 1
  });
  const [sellersData, setSellersData] = useState({});
  const [loadingSellers, setLoadingSellers] = useState(false);

  useEffect(() => {
    dispatch(fetchActiveRentals(filters.page, 20, filters.status));
  }, [dispatch, filters.page, filters.status]);

  // Cargar datos de los sellers cuando cambien los rentals
  useEffect(() => {
    const loadSellersData = async () => {
      if (!activeRentals || activeRentals.length === 0) return;

      setLoadingSellers(true);
      
      const sellerIds = [...new Set(
        activeRentals
          .filter(rental => rental.sellerId)
          .map(rental => rental.sellerId)
      )];

      const sellersMap = {};
      
      for (const sellerId of sellerIds) {
        try {
          const response = await fetch(`https://server.byraices.com/seller/${sellerId}`);
          const data = await response.json();
          if (data.success && data.data) {
            sellersMap[sellerId] = data.data;
          }
        } catch (error) {
          console.error(`Error al cargar seller ${sellerId}:`, error);
        }
      }
      
      setSellersData(sellersMap);
      setLoadingSellers(false);
    };

    loadSellersData();
  }, [activeRentals]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1 // Reset page when filters change
    }));
  };

  const filteredRentals = activeRentals.filter(rental => {
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      const seller = rental.sellerId ? sellersData[rental.sellerId] : null;
      const sellerFullName = seller ? `${seller.name} ${seller.last_name}`.toLowerCase() : '';
      
      return (
        rental.property?.title?.toLowerCase().includes(searchTerm) ||
        rental.title?.toLowerCase().includes(searchTerm) ||
        rental.tenants?.some(tenant => 
          tenant.fullName?.toLowerCase().includes(searchTerm)
        ) ||
        sellerFullName.includes(searchTerm)
      );
    }
    return true;
  });

  if (rentalsLoading) {
    return <div className={style.loading}>Cargando contratos...</div>;
  }

  if (loadingSellers && activeRentals.length > 0) {
    return <div className={style.loading}>Cargando información de agentes...</div>;
  }

  if (rentalsError) {
    return <div className={style.error}>Error: {rentalsError}</div>;
  }

  return (
    <div className={style.container}>
      <h1 className={style.title}>Contratos de Alquiler</h1>
      
      {/* Filtros */}
      <div className={style.filters}>
        <div className={style.filterGroup}>
          <label>Estado:</label>
          <select 
            value={filters.status} 
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className={style.select}
          >
            <option value="active">Activos</option>
            <option value="expired">Vencidos</option>
            <option value="terminated">Terminados</option>
            <option value="all">Todos</option>
          </select>
        </div>
        
        <div className={style.filterGroup}>
          <label>Buscar:</label>
          <input
            type="text"
            placeholder="Propiedad, inquilino o agente..."
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
            className={style.searchInput}
          />
        </div>
      </div>

      {/* Lista de contratos */}
      <div className={style.contractsList}>
        {filteredRentals.length === 0 ? (
          <div className={style.noData}>
            No se encontraron contratos con los filtros aplicados
          </div>
        ) : (
          filteredRentals.map(rental => {
            // Agregar datos del seller al objeto rental
            const rentalWithSeller = {
              ...rental,
              seller: rental.sellerId ? sellersData[rental.sellerId] : null
            };
            return (
              <RentalCard key={rental.id} rental={rentalWithSeller} />
            );
          })
        )}
      </div>

      {/* Estadísticas */}
      <div className={style.stats}>
        <p>Total de contratos: {filteredRentals.length}</p>
      </div>
    </div>
  );
};

export default ActiveContracts;